export default function NoProducts() {
  return (
    <div className="mt-6">
      No Products found yet!
    </div>
  );
};
